"use client";
import { useState } from "react";
import AppContainer from "../appContainer";
import { FlexBetween } from "../ui";
import SelectableBox from "../ui/selectableBox";
import FaqInformationSection from "./faqInformationSection";
import { IFaqCategory } from "@/interfaces";
import { faqCategorySelectorData } from "@/constants";

const FaqCategorySelectorSection = () => {
  const [selectedCategory, setSelectedCategory] = useState<IFaqCategory>(
    faqCategorySelectorData[0],
  );

  const handleCategorySelect = (id: string) => {
    const selected =
      faqCategorySelectorData.find((item) => item.id === id) ||
      faqCategorySelectorData[0];
    setSelectedCategory(selected);
  };

  return (
    <section className="relative z-30 mt-[-100px] mb-30 w-full lg:mt-[-152px]">
      <AppContainer className="h-auto">
        <FlexBetween
          gap={2}
          className="no-scrollbar mx-auto mb-20 w-full max-w-[700px] items-start overflow-x-auto lg:max-w-[900px] xl:max-w-full"
        >
          {faqCategorySelectorData.map((item) => {
            return (
              <SelectableBox
                {...item}
                isSelected={selectedCategory.id === item.id}
                key={item.id}
                onClick={(id: string) => handleCategorySelect(id)}
              />
            );
          })}
        </FlexBetween>
        <FaqInformationSection selectedCategory={selectedCategory} />
      </AppContainer>
    </section>
  );
};

export default FaqCategorySelectorSection;
